import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createPortal } from 'react-dom';
import styles from './styles.module.scss';
import { usePortalNode } from '../../../hooks/use-portal-node';
import { HeadingM, HeadingS, TextM } from '../../../../../infra/dls/components/typography/typography';
export var MobileHeaderStepTitle = function (_a) {
    var children = _a.children;
    var node = usePortalNode('mobile-header-step-title-portal');
    if (!node) {
        return null;
    }
    return createPortal(_jsx(HeadingS, { color: "primary", className: styles['header-step-name'], children: children }), node);
};
export var StepTitles = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, automationIdPart = _a.automationIdPart;
    var node = usePortalNode('step-titles-portal');
    var hasContent = !!title || !!subtitle;
    if (!node || !hasContent) {
        return null;
    }
    return createPortal(_jsxs("div", { className: styles['step-titles-container'], children: [_jsx(HeadingM, { color: "primary", automationId: "text:".concat(automationIdPart, ":title"), children: title }), !!subtitle && (_jsx(TextM, { color: "secondary", className: styles['step-subtitle'], automationId: "text:".concat(automationIdPart, ":subTitle"), children: subtitle }))] }), node);
};
